import React, { useState } from "react"
import { Card, Avatar, Flex, Button, Spin } from "antd"
import { EllipsisOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import styles from "./mobileStaffTable.module.css"
import { Text } from "ui/Typography"
import IconWithBg from "ui/IconWithBg"
import LoadMoreButton from "components/common/LoadMore"
import CustomDrawer from "ui/Drawer"

const MobileStaffTable = ({ staff, currentPage, totalPages, loading, onLoadMore, totalResults, getMenuItems }) => {
  const { t } = useTranslation()
  const [actionSheetOpen, setActionSheetOpen] = useState(false)
  const [selectedMember, setSelectedMember] = useState(null)

  const handleOpenActions = (member) => {
    setSelectedMember(member)
    setActionSheetOpen(true)
  }

  const handleActionClick = (action) => {
    action.onClick()
    setActionSheetOpen(false)
    setSelectedMember(null)
  }

  const menuItems = selectedMember ? getMenuItems(selectedMember) : []

  const isInitialLoading = loading && currentPage === 1

  return (
    <>
      <Spin spinning={isInitialLoading}>
        <Flex vertical gap={16}>
          {staff?.map((member) => (
            <Card key={member.id} className={styles.card} bodyStyle={{ padding: 16 }}>
              <Flex align="center" justify="space-between" gap={16} className="w-full">
                <Flex gap={16}>
                  <Avatar src={member.avatar} className={styles.avatar} />
                  <Flex wrap vertical gap={4} className={styles.infoContainer}>
                    <Flex wrap align="center" gap={8}>
                      <Text className={styles.name}>{member.name}</Text>
                      <Text className={styles.status}>{member.status}</Text>
                      <Text className={styles.role}>{member.role}</Text>
                    </Flex>
                    <Flex align="center" gap={8} className={styles.infoRow}>
                      <Text className={styles.info}>{member.title}</Text>
                      <div className={styles.dot} />
                      <Text className={styles.info}>{member.phone_number}</Text>
                      <div className={styles.dot} />
                      <Text className={styles.info}>{member.email}</Text>
                    </Flex>
                  </Flex>
                </Flex>
                <IconWithBg size={32} bgColor="surface-2" onClick={() => handleOpenActions(member)}>
                  <EllipsisOutlined />
                </IconWithBg>
              </Flex>
            </Card>
          ))}
          <LoadMoreButton
            currentPage={currentPage}
            totalPages={totalPages}
            loading={loading}
            onLoadMore={onLoadMore}
            totalAvailable={totalResults}
          />
        </Flex>
      </Spin>
      <CustomDrawer open={actionSheetOpen} setOpen={setActionSheetOpen} title={t("staff.table.actions")}>
        <Flex vertical gap={12}>
          {menuItems.map((item) => (
            <Button
              key={item.key}
              block
              size="large"
              className={item.danger ? styles.dangerActionButton : styles.actionButton}
              onClick={() => handleActionClick(item)}
            >
              {item.label}
            </Button>
          ))}
        </Flex>
      </CustomDrawer>
    </>
  )
}

export default MobileStaffTable
